import React from "react";

import { translation } from "@/i18n";
import { nsDialog } from "@/i18n/locales/dialog";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { ErrorCircle24Filled } from "@fluentui/react-icons";
import { DialogLocalErrorParam } from "../hooks";
import styles from "../index.module.css";

const useTranslation = translation.use(nsDialog);

export const DialogLocalError: React.FC<DialogLocalErrorParam> = ({
  onClick,
  displayMessage,
  errorMessages,
  dialogPhase,
  setDialogPhase,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={dialogPhase === "errorLocal"}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            <div className={styles.titleWithIcon}>
              <ErrorCircle24Filled className={styles.errorIcon} />
              {displayMessage}
            </div>
          </DialogTitle>
          <DialogContent>
            <div className={styles.errorInfoTitle}>
              {t.dialog.error.messageLabel()}
            </div>
            {errorMessages.map((msg, index) => (
              <div
                key={`errorDialog_${index}`}
                className={styles.errorResponse}
              >
                {msg}
              </div>
            ))}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                onClick && onClick();
                setDialogPhase(null);
              }}
            >
              {t.dialog.common.backButton()}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
